module.exports = __webpack_public_path__ + "img/DSC_0095.106b2834.jpg";